module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-ons-page', {
    attrs: {
      "modifier": "white"
    }
  }, [_c('v-ons-list-title', [_vm._v("Pages")]), _vm._v(" "), _c('v-ons-list', _vm._l((_vm.access), function(item, index) {
    return _c('v-ons-list-item', {
      key: item.title,
      attrs: {
        "modifier": _vm.md && 'nodivider'
      },
      on: {
        "click": function($event) {
          _vm.loadView(index)
        }
      }
    }, [_c('div', {
      staticClass: "left"
    }, [_c('v-ons-icon', {
      staticClass: "list-item__icon",
      attrs: {
        "fixed-width": "",
        "icon": item.icon
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "center"
    }, [_vm._v("\n        " + _vm._s(item.title) + "\n      ")]), _vm._v(" "), _c('div', {
      staticClass: "right"
    }, [_c('v-ons-icon', {
      attrs: {
        "icon": "fa-link"
      }
    })], 1)])
  })), _vm._v(" "), _c('v-ons-list-title', [_vm._v("Links")]), _vm._v(" "), _c('v-ons-list', _vm._l((_vm.links), function(item) {
    return _c('v-ons-list-item', {
      key: item.title,
      attrs: {
        "modifier": _vm.md && 'nodivider'
      },
      on: {
        "click": function($event) {
          _vm.loadLink(item.url)
        }
      }
    }, [_c('div', {
      staticClass: "left"
    }, [_c('v-ons-icon', {
      staticClass: "list-item__icon",
      attrs: {
        "fixed-width": "",
        "icon": item.icon
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "center"
    }, [_vm._v("\n        " + _vm._s(item.title) + "\n      ")]), _vm._v(" "), _c('div', {
      staticClass: "right"
    }, [_c('v-ons-icon', {
      attrs: {
        "icon": "fa-external-link"
      }
    })], 1)])
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6d3bc592","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Menu.vue
// module id = 38
// module chunks = 0